<template>
  <div class="course-statistic">
    <div class="content-wrapper">
      <p class="title">{{$t('m.sta_r_kcbam')}}</p>
      <div class="courselist-wrapper">
        <div class="left">{{$t('m.sta_r_xzkc')}}</div>
        <div class="right">
          <template v-for="(item , index) in lessonList">
            <span class="item" :class="{'now':currentIndex===index}"
                  @click="getClass(item , index)">{{decodeURIComponent(item.lessonname)}}</span>
          </template>
          <template v-if="totoalPage>10">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :page-size="10"
              :total="totoalPage">
            </el-pagination>
          </template>
        </div>
      </div>
      <div class="classlist-wrapper" v-if="currentLesson">
        <div class="top">
          <img :src="imgprefix+currentLesson.smallfaceimg" alt="faceimg" width="90" height="60">
          <span class="lessonname">《{{decodeURIComponent(currentLesson.lessonname)}}》</span>
          <!--<p class="float-right no-margin">-->
          <!--<span class="deco deco1"></span>-->
          <!--今日收入：1200元-->
          <!--</p>-->
          <!--<p class="float-right">-->
          <!--<span class="deco deco2"></span>-->
          <!--今日缴费：120人-->
          <!--</p>-->
          <!--<p class="float-right">-->
          <!--<span class="deco deco3"></span>-->
          <!--今日试听：8人-->
          <!--</p>-->
        </div>
        <template v-for="(item,index) in classList">
          <div class="class-item">
            <span class="deco deco1" :class="{'deco1':item.democlass=='1','deco0':item.democlass=='0'}"></span>
            <p class="classname">【{{decodeURIComponent(item.classmodename)}}】 {{decodeURIComponent(item.classname)}}
              <span class="icon" v-if="item.democlass==='1'">试听</span></p>
            <p class="time">{{$t('m.sta_r_kcrq')}}{{item.startdate}}</p>
            <p class="income">{{$t('m.sta_r_sr')}}
              <span class="num">{{item.totalpays}}</span>
            </p>
            <p class="enroll">{{$t('m.sta_r_bmrs')}}
              <span class="num">{{item.enrollnums}}</span>
            </p>
          </div>
        </template>
        <template v-if="totoalPage2>10">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentPage2"
            @current-change="handleCurrentChange2"
            :page-size="10"
            :total="totoalPage2">
          </el-pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: '',
        //---------------------课程列表及翻页-----------------------//
        currentPage: 1,
        totoalPage: 1,
        lessonList: [],                   //从服务端获取到的课程列表（总）
        currentIndex: -1,
        //---------------班级列表及翻页-----------------------//
        currentLesson: null,
        currentPage2: 1,
        totoalPage2: 1,
        classList: [],                   //从服务端获取到的班级列表（总）
      }
    },
    methods: {
      //---------------------课程列表及翻页-----------------------//
      //当页面发生改变时
      handleCurrentChange(val) {
        this.loadLessonList(val);
      },
      //根据传入的数字，获取相应的课程列表
      loadLessonList(page){
        //接口：查询指定用户课程列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryLesson',
            id: this.id,                //sessionid
            queryrid: this.schoolNow.rid,              //网校id
            pageno: page,
            pagesize: 10,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.lessonList = response.list;
            this.imgprefix = response.imgprefix;
            this.totoalPage = response.recordcount;
          }

        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      getClass(item, index){
        this.currentIndex = index;
        this.currentLesson = item;
        this.QueryClass(1);
      },
      QueryClass(page){
        this.classList=[];
        //接口：查询指定用户课程列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'Lesson',
            a: 'QueryClass',
            id: this.id,
            rid: this.currentLesson.rid,
            lessonid:this.currentLesson.id,
            pageno: page,
            pagesize: 10,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classList = response.list;
            this.totoalPage2 = response.recordcount;
          }

        }).catch((err) => {
        })
      },
      handleCurrentChange2(val) {
        this.QueryClass(val);
      },
    },
    created(){
      //请求课程列表
      this.loadLessonList(1);
      //根据当前选择的语言，设置radioSelect的默认选中项
      let language = loadLocal('language', false);
      if (language !== false) {
        if (language === 'en') {
          this.$i18n.locale = 'en-US';
        } else {
          this.$i18n.locale = 'zh-CN';
        }
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .course-statistic
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      padding-bottom: 20px
      min-width: 1166px
      background: #fff
      .title
        padding: 20px 0 38px 20px
        font-size: 20px
        color: #000000
        font-weight: bold
        line-height: 38px
      .courselist-wrapper
        margin: 0 30px 50px
        display: flex
        .left
          flex: 0 0 120px
          font-size: 16px
          line-height: 36px
          color: #888888
          vertical-align top
        .right
          .item
            display inline-block
            margin: 0 10px 15px 0
            padding: 0 10px
            height: 36px
            line-height: 36px
            border: 1px solid #d7d7d7
            box-sizing border-box
            font-size: 15px
            color: #666666
            border-radius: 4px
            cursor pointer
            &.now
              border: none
              background #3399ff
              color: #ffffff

      .classlist-wrapper
        padding-bottom: 30px
        margin: 0 30px
        border: 1px solid #e4e4e4
        .top
          padding: 14px 20px 28px
          img
            vertical-align top
          .lessonname
            margin-left: 16px
            font-size: 16px
            color: #000000
            line-height: 60px
          .float-right
            position relative
            top: 20px
            float: right
            height: 20px
            line-height: 20px
            font-size: 12px
            color: #555555
            margin-right: 40px
            &.no-margin
              margin: 0
            .deco
              margin-right: 10px
              display inline-block
              width: 5px
              height: 20px
              border-radius 3px
              vertical-align top
            .deco1
              background #ff6600
            .deco2
              background #3399ff
            .deco3
              background #33cc33
        .class-item
          margin: 0 30px 10px 126px
          height: 120px
          border-bottom: 2px solid #e4e4e4
          box-sizing border-box
          .deco
            float: left
            width: 4px
            height: 118px
          .deco1
            background #33cc33
          .deco0
            background #3399ff
          .classname
            padding: 18px 0 36px 14px
            font-size: 18px
            color: #000000
            font-weight: bold
            height: 22px
            line-height: 22px
            .icon
              margin-left: 12px
              display: inline-block
              width: 50px
              height: 22px
              text-align center
              line-height: 22px
              background #33cc33
              border-radius 11px
              font-size: 13px
              color: #fff
          .time, .period
            display inline-block
            margin-left: 24px
            height: 19px
            line-height: 19px
            width: 176px
            font-size: 14px
            color: #888888
          .period
            margin: 0
          .income, .enroll
            float: right
            width: 190px
            font-size: 14px
            color: #888888
            .num
              font-size: 20px
              color: #000000
              font-weight: bold

</style>



// WEBPACK FOOTER //
// src/page/statistic/coursestatistic/CourseStatistic.vue